import { useEffect } from 'react'
import { Content } from '@phrasee/phrasee-typings'

import useWebsockets from 'common/hooks/useWebsockets'

/**
 * Subscribes to Generation Topics still listed as Pending Generation Markers.
 * Re-runs when the WebSocket becomes ready again after reconnect so live
 * Generation Ready Notifications can arrive on the new connection.
 *
 * New markers created while connected are subscribed at generation start via
 * sendWebsocketMessage; this hook covers page load and reconnect recovery.
 */
const usePendingGenerationMarkersSubscription = (
  content: Content | undefined
): void => {
  const { sendJsonMessage, isConnectionReady } = useWebsockets()
  const contentId = content?._id
  // String key keeps the effect stable across content refetches with the same
  // markers, while still updating when markers are added or cleared.
  const pendingTopicsKey =
    content?.ws_messages?.map((message) => message.wsTopic).join('\0') ?? ''

  useEffect(() => {
    if (!contentId || !isConnectionReady || !pendingTopicsKey) {
      return
    }

    pendingTopicsKey.split('\0').forEach((wsTopic) => {
      sendJsonMessage({
        action: 'subscribe',
        topics: [wsTopic],
      })
    })
  }, [contentId, isConnectionReady, pendingTopicsKey, sendJsonMessage])
}

export default usePendingGenerationMarkersSubscription
